import { inject, Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { FirebaseApp, initializeApp } from "firebase/app";
import { getMessaging, getToken, Messaging } from "firebase/messaging";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyBcA3gn-g8Lwy2jcG3bz2SHC2XAutFTGjk",
  authDomain: "balmy-gearing-92214.firebaseapp.com",
  databaseURL: "https://balmy-gearing-92214.firebaseio.com/",
  projectId: "balmy-gearing-92214",
  storageBucket: "balmy-gearing-92214.firebasestorage.app",
  messagingSenderId: "943624393880",
  appId: "1:943624393880:web:fcff95291d3b4c04e92ced",
  measurementId: "G-J0PDMXXNZZ",
};

@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  private http = inject(HttpClient);
  private vapidKey = "BMLu45XYXPwwx5uqzEiNk1gAQXqg-g-7fbjR-tQq7x9dXIT8zWOqHXQQRQOHC_FLt4OfziYHeP-x-Q5ognmKKH0";
  private messaging!: Messaging;
  private app!: FirebaseApp;
  private isBrowser: boolean;
  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      // Inicializar Firebase
      this.app = initializeApp(firebaseConfig);
      this.messaging = getMessaging(this.app);
    }
  }
  /**
   * Solicita permiso de notificaciones y obtiene el token
   */
  async requestPermissionAndSubscribe(topic: string): Promise<void> {
    if (!this.isBrowser) return; // Evitar que se ejecute en el servidor
    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("Permiso de notificaciones denegado");
        return;
      }

      navigator.serviceWorker.getRegistration("/ngsw-worker.js").then((registration) => {
        if (!registration) {
          console.warn("No se encontró Service Worker registrado");
          return;
        }

        getToken(this.messaging, { vapidKey: this.vapidKey, serviceWorkerRegistration: registration })
          .then((token) => {
            if (token) {
              console.log("Token de notificación obtenido:", token);
              //this.subscribeToTopic(token, topic)
              // Puedes enviar este token al servidor para suscribirse a temas
            } else {
              console.warn("No se obtuvo un token de notificación.");
            }
          })
          .catch((error) => {
            console.error("Error obteniendo el token de notificación:", error);
          });
      });
    } catch (error) {
      console.error("Error en la solicitud de permiso:", error);
    }
  }

  /**
   * Suscribe al usuario a un tema específico en el backend
   * @param token Token del usuario
   * @param topic Tema al que se suscribirá el usuario
   */
  subscribeToTopic(token: string, topic: string): void {
    const url = "https://tu-servidor.com/api/subscribe-to-topic.php";
    this.http.post(url, { token, topic }).subscribe({
      next: (response) => console.log("Usuario suscrito al tema:", response),
      error: (error) => console.error("Error al suscribir al tema:", error),
    });
  }
}
